import React from "react";

const InsightsGuide = () =>{
    sessionStorage.setItem('reportStatus' , 'false');
    return ( 
        <>
            <h3 className="font-24 font-semi-bold mb-36"> Insights</h3>
            <p>The insights section can give additional information regarding cost per part calculations. </p>
            <img src="/assets/insight-guide-1.png" alt="" className="img-fluid" />
        </>
    )
}

export default InsightsGuide;